const fmt = (d, opts) => d ? new Date(d).toLocaleDateString('ru-RU', opts) : ''
const fmtDT = (d, opts) => d ? new Date(d).toLocaleString('ru-RU', opts) : ''

// "05.06.2024"
export const formatDate = (d) => fmt(d, { day: '2-digit', month: '2-digit', year: 'numeric' })

// "05.06.2024, 14:30"
export const formatDateTime = (d) => fmtDT(d, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })

// "05.06 14:30" (без года — для компактных блоков)
export const formatDateTimeCompact = (d) => fmt(d, { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })

// "5 июн. 2024" — для списка глав
export const formatDateChapter = (d) => fmt(d, { day: 'numeric', month: 'short', year: 'numeric' })

// "5 июня 2024 г., 14:30" — для комментариев
export const formatDateComment = (d) => fmt(d, { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })
